import { Activity, BarChart3, Bell, Home, Users, UserRound, type LucideIcon } from 'lucide-react';

export interface NavItem {
  id: string;
  label: string;
  icon: LucideIcon;
  to: string;
  matchPaths: string[];
  testID: string;
}

/**
 * Itens canonicos de navegacao primaria.
 * `matchPaths` lista os prefixos de rota considerados "ativos" para esse item
 * (ex: `/groups/*` ativa o tab Grupos).
 */
export const PRIMARY_NAV_ITEMS: NavItem[] = [
  {
    id: 'home',
    label: 'Início',
    icon: Home,
    to: '/home',
    matchPaths: ['/home', '/expenses'],
    testID: 'nav-home',
  },
  {
    id: 'groups',
    label: 'Grupos',
    icon: Users,
    to: '/groups',
    matchPaths: ['/groups', '/invite'],
    testID: 'nav-groups',
  },
  {
    id: 'reports',
    label: 'Relatórios',
    icon: BarChart3,
    to: '/reports',
    matchPaths: ['/reports'],
    testID: 'nav-reports',
  },
  {
    id: 'profile',
    label: 'Perfil',
    icon: UserRound,
    to: '/profile',
    matchPaths: ['/profile'],
    testID: 'nav-profile',
  },
];

/** Itens secundarios mostrados no rodape da sidebar / topbar do desktop. */
export const SECONDARY_NAV_ITEMS: NavItem[] = [
  {
    id: 'notifications',
    label: 'Notificações',
    icon: Bell,
    to: '/notifications',
    matchPaths: ['/notifications'],
    testID: 'nav-notifications',
  },
  {
    id: 'activity',
    label: 'Atividade',
    icon: Activity,
    to: '/reports/history',
    matchPaths: ['/reports/history'],
    testID: 'nav-activity',
  },
];

export function isItemActive(pathname: string, item: NavItem): boolean {
  return item.matchPaths.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}
